// extracted by mini-css-extract-plugin
module.exports = {"TickCheckbox":"TickCheckbox_TickCheckbox__cdlz3","tick":"TickCheckbox_tick__LvZFo","untick":"TickCheckbox_untick__9Ak8_"};